export const CATEGORIES = [
    {
        id: "stefna",
        index: 0,
        name_is: "Stefna og skipulag",
        name_en: "Strategy & Organization",
        colorPrimary: "#009448",
        colorSecondary: "#0B5D3B",
        pair: "green",
    },
    {
        id: "markmid",
        index: 1,
        name_is: "Markmið og framkvæmd",
        name_en: "Goals & Execution",
        colorPrimary: "#0B5D3B",
        colorSecondary: "#009448",
        pair: "green",
    },
    {
        id: "umhverfi",
        index: 2,
        name_is: "Umhverfi og ábyrgð",
        name_en: "Environment & Responsibility",
        colorPrimary: "#C54E3F",
        colorSecondary: "#7A5A3A",
        pair: "warm",
    },
    {
        id: "soun",
        index: 3,
        name_is: "Sóun og hagræðing",
        name_en: "Waste & Optimization",
        colorPrimary: "#7A5A3A",
        colorSecondary: "#C54E3F",
        pair: "warm",
    },
    {
        id: "mannaudur",
        index: 4,
        name_is: "Mannauðsmál",
        name_en: "Human Resources",
        colorPrimary: "#1391BC",
        colorSecondary: "#97D1AF",
        pair: "cool",
    },
    {
        id: "breyting",
        index: 5,
        name_is: "Breytingargeta",
        name_en: "Change Capacity",
        colorPrimary: "#97D1AF",
        colorSecondary: "#1391BC",
        pair: "cool",
    },
    {
        id: "samkeppni",
        index: 6,
        name_is: "Samkeppni og kröfur",
        name_en: "Competition & Requirements",
        colorPrimary: "#E2B93B",
        colorSecondary: "#C6E5CE",
        pair: "sunny",
    },
    {
        id: "imynd",
        index: 7,
        name_is: "Ímynd og markaðsþrýstingur",
        name_en: "Image & Market Pressure",
        colorPrimary: "#C6E5CE",
        colorSecondary: "#E2B93B",
        pair: "sunny",
    },
];

export const SCALE_A = {
    id: "readiness",
    labels_is: [
        "Ekki til staðar",
        "Að litlu leyti",
        "Að einhverju leyti",
        "Að mestu leyti",
        "Að fullu",
    ],
    labels_en: [
        "Not in place",
        "To a small extent",
        "To some extent",
        "To a large extent",
        "Fully in place",
    ],
};

export const SCALE_B = {
    id: "pressure",
    labels_is: [
        "Mjög lítið",
        "Frekar lítið",
        "Hvorki né",
        "Frekar mikið",
        "Mjög mikið",
    ],
    labels_en: [
        "Very little",
        "Rather little",
        "Neither",
        "Rather much",
        "Very much",
    ],
};

export const NA_VALUE = "na";
export const NA_LABEL_IS = "Á ekki við";
export const NA_LABEL_EN = "Not applicable";

export function isNumericAnswer(value) {
    return typeof value === "number" && value >= 1 && value <= 5;
}

export const QUESTIONS = [
    {
        id: 1,
        categoryId: "stefna",
        scale: "A",
        text_is:
            "Er fyrirtækið með formlegar stefnur eða verklag á lykilsviðum, eins og umhverfismálum, vinnuvernd, jafnrétti eða persónuvernd?",
        text_en:
            "Does the company have formal policies or procedures in key areas such as environment, occupational safety, equality, or data protection?",
        dataStatus: "manual_now_data_later",
    },
    {
        id: 2,
        categoryId: "stefna",
        scale: "A",
        text_is:
            "Er skýrt hver innan fyrirtækisins ber ábyrgð á að fylgja þessum málum eftir?",
        text_en:
            "Is it clear who within the company is responsible for following up on these matters?",
        dataStatus: "manual_now_data_later",
    },
    {
        id: 3,
        categoryId: "stefna",
        scale: "A",
        text_is:
            "Eru stefnur og verklag virkur hluti af daglegum rekstri, eða eru þau helst til á pappír?",
        text_en:
            "Are policies and procedures an active part of daily operations, or do they mostly exist on paper?",
        dataStatus: "manual_only",
    },
    {
        id: 4,
        categoryId: "markmid",
        scale: "A",
        text_is:
            "Er fyrirtækið með skýr markmið tengd lykilsviðum rekstursins, eins og umhverfi, sóun, starfsfólki eða ábyrgð?",
        text_en:
            "Does the company have clear goals related to key operational areas such as environment, waste, staff, or responsibility?",
        dataStatus: "manual_now_data_later",
    },
    {
        id: 5,
        categoryId: "markmid",
        scale: "A",
        text_is:
            "Eru þessi markmið tengd við raunveruleg verkefni, aðgerðir eða ábyrgð innan fyrirtækisins?",
        text_en:
            "Are these goals linked to actual projects, actions, or responsibilities within the company?",
        dataStatus: "hybrid",
    },
    {
        id: 6,
        categoryId: "markmid",
        scale: "A",
        text_is:
            "Fylgist fyrirtækið reglulega með því hvort þessi markmið séu að nást?",
        text_en:
            "Does the company regularly monitor whether these goals are being achieved?",
        dataStatus: "hybrid",
    },
    {
        id: 7,
        categoryId: "umhverfi",
        scale: "A",
        text_is:
            "Vinnur fyrirtækið í dag með skipulögðum hætti að umhverfis- eða ábyrgðarmálum?",
        text_en:
            "Does the company currently work in an organized way on environmental or responsibility matters?",
        dataStatus: "manual_now_data_later",
    },
    {
        id: 8,
        categoryId: "umhverfi",
        scale: "A",
        text_is:
            "Er fyrirtækið farið að mæla, meta eða sýna fram á stöðu sína í umhverfis- eða ábyrgðarmálum?",
        text_en:
            "Has the company started to measure, assess, or demonstrate its position on environmental or responsibility matters?",
        dataStatus: "live_data_ready",
    },
    {
        id: 9,
        categoryId: "umhverfi",
        scale: "A",
        text_is:
            "Vinnur fyrirtækið markvisst að því að byggja upp umhverfisvitund og ábyrg vinnubrögð í rekstrinum?",
        text_en:
            "Is the company actively working to build environmental awareness and responsible practices in operations?",
        dataStatus: "hybrid",
    },
    {
        id: 10,
        categoryId: "soun",
        scale: "B",
        text_is:
            "Sér fyrirtækið skýr tækifæri til að draga úr sóun í rafmagni eða heitu vatni?",
        text_en:
            "Does the company see clear opportunities to reduce waste in electricity or hot water usage?",
        dataStatus: "live_data_ready",
    },
    {
        id: 11,
        categoryId: "soun",
        scale: "B",
        text_is:
            "Sér fyrirtækið skýr tækifæri til að draga úr matarsóun eða bæta flokkunarhlutfall í úrgangsmálum?",
        text_en:
            "Does the company see clear opportunities to reduce food waste or improve waste sorting rates?",
        dataStatus: "live_data_ready",
    },
    {
        id: 12,
        categoryId: "soun",
        scale: "B",
        text_is:
            "Telur fyrirtækið líklegt að úrbætur á þessum sviðum geti skilað mælanlegum rekstrarávinningi?",
        text_en:
            "Does the company believe improvements in these areas could deliver measurable operational benefits?",
        dataStatus: "hybrid",
    },
    {
        id: 13,
        categoryId: "mannaudur",
        scale: "B",
        text_is:
            "Hefur fyrirtækið góða mynd af vellíðan og almennri stöðu starfsfólks?",
        text_en:
            "Does the company have a good picture of employee wellbeing and general staff status?",
        dataStatus: "live_data_ready",
    },
    {
        id: 14,
        categoryId: "mannaudur",
        scale: "B",
        text_is:
            "Fylgist fyrirtækið með lykilþáttum eins og veikindadögum, starfsmannaveltu eða öðrum mannauðsvísum?",
        text_en:
            "Does the company track key factors like sick days, staff turnover, or other HR metrics?",
        dataStatus: "live_data_ready",
    },
    {
        id: 15,
        categoryId: "mannaudur",
        scale: "A",
        text_is:
            "Vinnur fyrirtækið markvisst með fræðslu, starfsþróun, þátttöku eða helgun starfsfólks?",
        text_en:
            "Does the company actively work with education, professional development, participation, or employee engagement?",
        dataStatus: "hybrid",
    },
    {
        id: 16,
        categoryId: "breyting",
        scale: "B",
        text_is:
            "Er starfsfólk almennt tilbúið að taka þátt í umbótum og breytingum?",
        text_en:
            "Is staff generally willing to participate in improvements and changes?",
        dataStatus: "hybrid",
    },
    {
        id: 17,
        categoryId: "breyting",
        scale: "A",
        text_is:
            "Er skýrt innan fyrirtækisins hvaða breytingar eða umbætur skipta mestu máli?",
        text_en:
            "Is it clear within the company which changes or improvements matter most?",
        dataStatus: "manual_now_data_later",
    },
    {
        id: 18,
        categoryId: "breyting",
        scale: "A",
        text_is:
            "Gengur fyrirtækinu almennt vel að innleiða ný vinnubrögð eða breytingar í rekstrinum?",
        text_en:
            "Does the company generally succeed at implementing new practices or changes in operations?",
        dataStatus: "hybrid",
    },
    {
        id: 19,
        categoryId: "samkeppni",
        scale: "B",
        text_is:
            "Finnur fyrirtækið fyrir auknum væntingum eða kröfum frá viðskiptavinum, samstarfsaðilum eða markaði?",
        text_en:
            "Does the company feel increasing expectations or demands from customers, partners, or the market?",
        dataStatus: "manual_only",
    },
    {
        id: 20,
        categoryId: "samkeppni",
        scale: "B",
        text_is:
            "Er fyrirtækið í aðstæðum þar sem útboð, regluverk eða formlegar kröfur geta haft áhrif á reksturinn?",
        text_en:
            "Is the company in a situation where tenders, regulations, or formal requirements can affect operations?",
        dataStatus: "manual_now_data_later",
    },
    {
        id: 21,
        categoryId: "samkeppni",
        scale: "B",
        text_is:
            "Er líklegt að fyrirtækið tapi samkeppnisforskoti ef það bregst ekki við þessum þróunum?",
        text_en:
            "Is it likely the company will lose competitive advantage if it doesn't respond to these developments?",
        dataStatus: "manual_only",
    },
    {
        id: 22,
        categoryId: "imynd",
        scale: "B",
        text_is:
            "Skiptir það miklu máli fyrir fyrirtækið að viðhalda trúverðugri og sterkri ásýnd út á við?",
        text_en:
            "Is it important for the company to maintain a credible and strong external image?",
        dataStatus: "manual_only",
    },
    {
        id: 23,
        categoryId: "imynd",
        scale: "B",
        text_is:
            "Er fyrirtækið í aðstæðum þar sem markhópur, sýnileiki eða almenn ímynd hefur mikil áhrif á stöðu þess?",
        text_en:
            "Is the company in a situation where target audience, visibility, or general image significantly affects its position?",
        dataStatus: "manual_now_data_later",
    },
    {
        id: 24,
        categoryId: "imynd",
        scale: "B",
        text_is:
            "Getur ímynd fyrirtækisins haft bein áhrif á sölu, ráðningar eða samkeppnisstöðu?",
        text_en:
            "Can the company's image directly affect sales, recruitment, or competitive position?",
        dataStatus: "manual_only",
    },
];

export const PACKAGE_COLORS = {
    kveikja: "#009448",
    vaxa: "#E2B93B",
    efla: "#1391BC",
    dafna: "#7A5A3A",
    none: "#8A8F8C",
};

export function getQuestionsForCategory(categoryId) {
    return QUESTIONS.filter((q) => q.categoryId === categoryId);
}

export function getScale(type) {
    return type === "A" ? SCALE_A : SCALE_B;
}
